import { CSSProperties } from "react";

const style: CSSProperties = {
  display: "block",
  textAlign: "left",
};

export const menuItem = {
  fontWeight: "bold",
  fontSize: 13,
  display: "flex",
  flexDirection: "row",
};
export const menuItemLabel = { padding: 3, paddingLeft: 10, display: "block" };

export default style;
